import React from 'react';
import PropTypes from 'prop-types';
import styles from './InvestNow.module.css';
import vector from '../../images/Vector.svg';
import backvector from '../../images/backvector.svg';

const DesktopButtons = props => {
  const { goBack, prevQuestion, url, isEnabled, goToLandpage } = props;
  return (
    <div className={styles.buttonsContainer}>
      <div className={styles.startInvestmentContainer}>
        <button
          type="button"
          onClick={goBack}
          className={prevQuestion.length === 0 ? styles.goBackButtonDisabled : styles.goBackButton}
          disabled={prevQuestion.length === 0}
        >
          <img className={styles.backVector} src={backvector} alt="" />
          GO BACK
        </button>
      </div>
      <div className={styles.startInvestmentContainer}>
        <a className={styles.docusignLink} href={url} target="_blank" rel="noopener noreferrer">
          <button
            type="button"
            onClick={goToLandpage}
            className={!isEnabled ? styles.notEnabled : styles.startInvestmentButtonEnabled}
            disabled={!isEnabled}
          >
            START INVESTMENT
            <img className={styles.vector} src={vector} alt="" />
          </button>
        </a>
      </div>
    </div>
  );
};

DesktopButtons.propTypes = {
  isEnabled: PropTypes.bool,
  prevQuestion: PropTypes.arrayOf(Object),
  goBack: PropTypes.func,
  url: PropTypes.string,
  goToLandpage: PropTypes.func
};
DesktopButtons.defaultProps = {
  isEnabled: false,
  prevQuestion: [],
  goBack: () => {},
  url: '',
  goToLandpage: () => {}
};

export default DesktopButtons;
